import { render, staticRenderFns } from "./dragFormTable.vue?vue&type=template&id=431239e9&"
import script from "./dragFormTable.vue?vue&type=script&lang=js&"
export * from "./dragFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports